import React, { useState, useEffect, useRef } from 'react'
import './CustomTable.css';
import { getIcon, Icon, ICONS, Loader, SuccessModal, Tooltip } from '@ohif/ui';
const sortIconMap = {
  descending: 'sorting-active-up',
  ascending: 'sorting-active-down',
  none: 'sorting',
};
import classnames from 'classnames';
import { fetchPatientCount, postMWLItems, postPatientData } from '@custom/Appointments/mwlHelperMethods';
import { servicesManager } from '../../../../app/src/App';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getReportId from '@custom/rtk-apis/report/GetReportId';
import { revertStatus } from '@custom/store/slices/report/getReportIdSlice';
import { useTheme } from "../../../src/contextProviders"
import { Link } from 'react-router-dom';
import { _roleType } from '@custom/Utils/constants/appConstants';
import { AppDispatch, RootState } from '@custom/store/store';
import getAppointmentStudy from '@custom/rtk-apis/appointment/getStudy';
import ToggleSwitch from '@custom/Pacs/togglePacs';
import fetchActiveMachineList from '@custom/rtk-apis/activeMachine/activeMachineList';

const CustomTable = ({ columns, data, actions, searchQuery, from, userDetails, setClickedItem, clickedItem, moreActions = [], approvedHospitals }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const getReportIdData = useSelector((state: RootState) => {
    return state?.getReportIdResponse
  });
  const { status, result, msg, loading, error } = useSelector((state: RootState) => state.getAppointmentStudyResponse);
  const dropdownRef = useRef([]);
  const moreActionsDropdownRef = useRef([]);
  const { uiNotificationService } = servicesManager.services;
  const { isDarkMode, toggleTheme } = useTheme();
  const [keyStore, setkeyStore] = useState({});
  const [isSort, setisSort] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openMoreActionsDropdownId, setOpenMoreActionsDropdownId] = useState(null);
  const [successPopup, setSuccessPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const getInitials = (name) => {
    const [firstName, lastName] = name?.split(' ');
    return firstName?.charAt(0).toUpperCase() + (lastName ? lastName?.charAt(0).toUpperCase() : '');
  };

  const isSortingEnabled = data?.length > 0 && data?.length <= 100;

  const handleFilterLabelClick = displayName => {
    if (isSortingEnabled) {
      let _sortDirection = 'descending';

      const key = displayName
      const keyStatus = checkKeyStatus(key)

      const sortBy = key
      const sortDirection = keyStore[key] ? keyStore[key] : _sortDirection
      if (sortBy === key) {
        if (sortDirection === 'ascending') {
          _sortDirection = 'descending';
        } else if (sortDirection === 'descending') {
          _sortDirection = 'ascending';
        }
      }


      const sortedDataToShow = sortData(data, key, _sortDirection);
      data = sortedDataToShow;
      setisSort(true);
      keyStore[key] = _sortDirection
      setkeyStore(keyStore)
    }
  };
  useEffect(() => {
    setisSort(false)

  }, [isSort]);

  const onLabelClick = (key, sort) => {
    if (sort) {
      handleFilterLabelClick(key);
    }
  }
  const sortData = (data, key, sortDirection) => {

    return data.sort((a, b) => {
      if (sortDirection === 'ascending') {
        return a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0;
      } else if (sortDirection === 'descending') {
        return a[key] < b[key] ? 1 : a[key] > b[key] ? -1 : 0;
      }
      return 0;
    });
  }
  const checkKeyStatus = (key) => {
    if (keyStore.hasOwnProperty(key)) {
      return true
    }
    else {
      return false
    }
  }
  const toggleDropdown = (index) => {
    setOpenDropdownId(openDropdownId === index ? null : index);
  };

  const toggleMoreActionsDropdown = (index) => {
    setOpenMoreActionsDropdownId(openMoreActionsDropdownId === index ? null : index);
  }

  const handleGenerateReport = (item) => {
    if (!moreActions || moreActions.length === 0) {
      uiNotificationService.show({
        title: 'No templates found',
        message: 'Error occurred while generating report',
        type: 'error',
      });
      navigate('/templatelist');
      return;
    }

    navigate('/createReport', { state: { data: item?.appointmentDetails } });
  };

  const handleStudyNavigation = async (item) => {
    const payload = item?.patientId;

    try {
      const response = await dispatch(getAppointmentStudy(payload)).unwrap();

      if (response?.[0]?.["0020000D"]?.Value?.[0]) {
        const studyInstanceUID = response[0]["0020000D"].Value[0];
        navigate(`/viewer?StudyInstanceUIDs=${studyInstanceUID}&modalitytype=${item?.modality}`);
      } else {
        console.error('StudyInstanceUID not found in response:', response);

        uiNotificationService.show({
          title: 'No studies found',
          message: '',
          type: 'error',
        });
      }
    } catch (error) {
      if (error.name === 'SyntaxError' && error.message.includes('Unexpected end of JSON input')) {
        console.error('Empty or invalid JSON response:', error);

        uiNotificationService.show({
          title: 'No studies found',
          message: '',
          type: 'error',
        });
      } else {
        console.error('Error during API call:', error);

        uiNotificationService.show({
          title: 'No studies found',
          message: '',
          type: 'error',
        });
      }
    }
  };

  const getColorForIcons = (index) => {
    switch (index % 5) {
      case 0:
        return '#2050D2'
      case 1:
        return '#51A196'
      case 2:
        return '#B87EEE'
      case 3:
        return '#D92D20'
      case 4:
        return '#C5A600'
      default:
        return '';
    }
  }


  async function sendToMWLHandler(item) {
    try {
      const machinelist = await dispatch(fetchActiveMachineList({ limit: 50, pageNumber: 1, search: '' })).unwrap()
      if (!localStorage.getItem('local_pacs_access_token') && !sessionStorage.getItem('local_pacs_access_token')) {
        uiNotificationService.show({
          title: 'Send to MWL',
          message: 'No PACS is ACTIVE. Please ACTIVATE a PACS and try again.',
          type: 'error',
        });
        return;
      }
      setIsLoading(true);

      const countRes = await fetchPatientCount(item?.uhid);

      if (countRes === null) {
        uiNotificationService.show({
          title: 'Send to MWL',
          message: 'Error occurred while adding patient to MWL',
          type: 'error',
        });
        setIsLoading(false);
        return;
      }
      let aeTitle = '';
      if (item.modality) {
        const machineGroup = machinelist?.result?.list?.find((group) => group.machineType === item.modality);
        if (machineGroup) {
          const machine = machineGroup.machines.find((m) => m.machineName === item?.appointmentDetails?.machineName);
          aeTitle = machine ? machine.aeTitle : '';
        }
      }

      const mwlDetails = {
        patId: item?.uhid,
        patAge: `${String(item?.age).padStart(3, "0")}Y`,
        modality: item?.modality,
        stepProcedureDisc: item?.studyRegion,
        accessionNumber: item?.patientId,
        aeTitle: aeTitle,
      };

      if (countRes?.count > 0) {
        const mwlRes = await postMWLItems(mwlDetails);

        if (!mwlRes) {
          uiNotificationService.show({
            title: 'Send to MWL',
            message: 'Error occurred while adding patient to MWL',
            type: 'error',
          });
          setIsLoading(false);
          return;
        }
      } else {
        const patientDetails = {
          patName: item?.name,
          patId: item?.uhid,
          patIdIssuer: 'QSS',
          patDob: item?.dob?.replace(/-/g, ''),
          patSex: item?.gender === 'Male' ? 'M' : item.gender === 'Female' ? 'F' : 'O',
        };

        const isPatAdded = await postPatientData(patientDetails);

        if (isPatAdded) {
          const mwlRes = await postMWLItems(mwlDetails);

          if (!mwlRes) {
            uiNotificationService.show({
              title: 'Send to MWL',
              message: 'Error occurred while adding patient to MWL',
              type: 'error',
            });
            setIsLoading(false);
            return;
          }
        } else {
          uiNotificationService.show({
            title: 'Send to MWL',
            message: 'Error occurred while adding patient to MWL',
            type: 'error',
          });
          setIsLoading(false);
          return;
        }
      }


      if(item?.appointmentDetails?.extraModalities?.length > 0) {

        item.appointmentDetails.extraModalities.forEach(async (element) => {

          if (element?.modality) {
            const machineGroup = machinelist?.result?.list?.find((group) => group.machineType === element?.modality);
            if (machineGroup) {
              const machine = machineGroup.machines.find((m) => m.machineName === element?.machineName);
              aeTitle = machine ? machine.aeTitle : '';
            }
          }
          const extraMwlDetails = {
            patId: item?.uhid,
            patAge: `${String(item?.age).padStart(3, "0")}Y`,
            modality: element.modality,
            stepProcedureDisc: element.studyRegion,
            accessionNumber: item?.patientId,
            aeTitle: aeTitle,
          };

          const extraMwlRes = await postMWLItems(extraMwlDetails);

          if (!extraMwlRes) {
            uiNotificationService.show({
              title: 'Send to MWL',
              message: 'Error occurred while adding patient to MWL',
              type: 'error',
            });
            setIsLoading(false);
          }
        })
    }
      setIsLoading(false);
      setSuccessPopup(true);
    } catch (error) {
      uiNotificationService.show({
        title: 'Send to MWL',
        message: 'An unexpected error occurred',
        type: 'error',
      });
      setIsLoading(false);
    }
  }


  const getIconType = (key, value) => {
    if (value === '--') return '';

    if (key === 'gender' && value === 'Male') {
      return 'maleIcon';
    }
    else if (key === 'gender' && value === 'Female') {
      return 'femaleIcon';
    }
    else if (key === 'gender' && value === 'Others') {
      return 'othersIcon';
    }
    else if (key === 'gender' && value === 'Other') {
      return 'othersIcon';
    }
    else if (key === 'role' && value === 'Hospital Superadmin') {
      return 'clinician';
    }
    else if (key === 'role' && value === 'Radiologist') {
      return 'radiologist';
    }
    else if (key === 'role' && value === 'Nurse') {
      return 'nurse';
    }
    else if (key === 'role' && value === 'Resident') {
      return 'radiologist';
    }
    else if (key === 'role' && value === 'Clinician') {
      return 'clinician';
    }
    else if (key === 'role' && value === 'Front Desk') {
      return 'frontDesk';
    }
    else if (key === 'role' && value === 'Admin') {
      return 'clinician';
    }
    else if (key === 'role' && value === 'Technician') {
      return 'clinician';
    }
    else if (key === 'role' && value === 'Technician Radiology') {
      return 'clinician';
    }
    else if (key === 'role' && value === 'Pathologist') {
      return 'clinician';
    }
    else if (key === 'role' && value === _roleType.pathologistAdmin) {
      return 'clinician';
    }
    else if (key === 'role' && value === _roleType.radiologistAdmin) {
      return 'radiologist';
    }
    else if (key === 'role' && value === _roleType.government) {
      return 'clinician';
    }
    else if (key === 'superAdmin') {
      return 'superAdmin';
    }
    else if (key === 'userName') {
      return 'superAdmin';
    }
    else if (key === 'port') {
      return 'port';
    }
    else if (key === 'plan') {
      return 'plan';
    }
    else if (key === 'doctorPayout') {
      return 'payOutIcon';
    }
    else if (key === 'credit') {
      return 'payOutIcon';
    }
    else if (key === 'price') {
      return 'payOutIcon';
    }
    else if (key === 'localPacsAddress') {
      return 'localAddressIcon';
    }
    else if (key === 'totalMachine') {
      return 'machineIcon';
    }
    else if (key === 'machineName') {
      return 'machineIcon';
    }
    else if (key === 'pricing') {
      return 'payOutIcon';
    }
    else if (key === 'consultationChargesFormatted') {
      return 'payOutIcon';
    }
    else if (key === 'doctorName') {
      return 'clinician';
    }
    else if (key === 'Price') {
      return 'payOutIcon';
    }

    return '';
  }

  const checkIfDynamicClass = (key) => ((from === 'teleradiologistAuditLogs' && key === 'gender') || (from === 'user' && key === 'role') || (from === 'hospital' && key === 'superAdmin') || (from === 'patient' && key === 'gender') || (from === 'report' && key === 'gender') || (from === 'appointment' && key === 'gender') || (from === 'rollback' && key === 'gender') || (from === 'teleradiology' && key === 'userName') || (from === 'machines' && key === 'machineType') || (from === 'pacs' && key === 'port') || (from === 'reviewReport' && key === 'gender') || (from === 'audit' && key === 'gender') || (from === 'billingInvoice' && key === 'gender') || (from === 'teleserviceprice' && key === 'price') || (from === 'modalityPricing' && key === 'credit') || (from === 'teleradiologistPayouts' && key === 'doctorPayout') || (from === 'creditsforcasetocase' && key === 'credit') || (from === 'activemachine' && key === 'totalMachine') || (from === 'pacs' && key === 'localPacsAddress') || (from === 'machines' && key === 'machineName') || (from === 'billingPackage' && key === 'pricing') || (from === 'consultation' && key === 'consultationChargesFormatted') || (from === 'urgencyCharges' && key === 'price') || (from === 'doctorDiscountHike' && key === 'doctorName') || (from === 'pricing' && key === 'price') || (from === 'investigation' && key === 'Price'));

  const getDynamicClass = (index, key, value) => {
    if (checkIfDynamicClass(key)) {
      if (key === 'gender') {
        switch (value) {
          case 'Male':
            return 'btn btn__primary btn__outlined btn--rounded w-170';
          case 'Female':
            return 'btn btn__purple btn__outlined btn--rounded w-170';
          case 'Others':
            return 'btn btn__secondary btn__outlined btn--rounded w-170';
          case 'Other':
            return 'btn btn__secondary btn__outlined btn--rounded w-170';
          default:
            return 'btn btn__warm btn__outlined btn--rounded w-170';
        }
      }

      switch (index % 5) {
        case 0:
          return 'btn btn__secondary btn__outlined btn--rounded w-170';
        case 1:
          return 'btn btn__primary btn__outlined btn--rounded w-170';
        case 2:
          return 'btn btn__purple btn__outlined btn--rounded w-170';
        case 3:
          return 'btn btn__danger btn__outlined btn--rounded w-170';
        case 4:
          return 'btn btn__warm btn__outlined btn--rounded w-170';
        default:
          return '';
      }

    }
    return "cellText__dark"
  }
  const intialUserClass = (index, key) => {
    switch (index % 4) {
      case 0:
        return 'profile__initials initial-first';
      case 1:
        return 'profile__initials initial-second';
      case 2:
        return 'profile__initials initial-third';
      case 3:
        return 'profile__initials initial-forth';
      default:
        return 'profile__initials'
    }
  }

  const handleOpenReport = (item) => {
    let obj: Object;
    if (item?.studyInstanceUID) {
      obj = {
        studyInstanceUID: item?.studyInstanceUID
      }
    } else {
      obj = {
        wsiId: item?.wsiId
      }
    }
    dispatch(getReportId(obj))
  }

  useEffect(() => {
    if (getReportIdData?.status === "SUCCESS") {
      if (getReportIdData?.result?._id) {
        navigate(`/report/preview/${getReportIdData?.result?._id}`, {
          state: {
            from: "study-research"
          }
        })
      }
    }
    dispatch(revertStatus());
  }, [getReportIdData])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.some(ref => ref && ref.contains(event.target))) {
        setOpenDropdownId(null);
      }
      if (moreActionsDropdownRef.current && !moreActionsDropdownRef.current.some(ref => ref && ref.contains(event.target))) {
        setOpenMoreActionsDropdownId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const checkDataToShowInWorkList = (item, from) => {
    let data = item?.reviewerDetail.find(t => t.userId === sessionStorage.getItem('userId'))
    if (data.status === 'Authorized') {
      return { status: data.status, value: true }
    }
    else if (data.status === 'Reviewed') {
      return { status: data.status, value: true }
    }
    else {
      return { status: data.status, value: false }
    }
  }

  function getStatusColor(status) {
    const statusColors = {
      "Confirmed": "#3B877D",
      "Cancelled": "#FF0000",
      "Scheduled": "#3B877D",
      "Rescheduled": "#FF8C00",
      "Completed": "#2050d2",
      "Approved": "#2050d2",
      "Draft": "#2050d2",
      "Authorized": "#AF52DE",
      "Redo": "#FF0000",
      "Paid": "#3B877D",
      "Paid (Cancelled)": "#FF0000",
      "Unpaid (Cancelled)": "#FF0000",
      "Refund (Paid)": "#3B877D",
      "Refund (Unpaid)": "#2050d2",
      "Subsidy": "#FF8C00",
      "Rejected": "#FF0000",
      "Accepted": "#3B877D",
      "Pending": "#FF8C00",
      "Auto Rejected": "#FF0000",
    };

    return statusColors[status] || "inherit";
  }

  return (
    <div className='tableContainer__wrap'>
      <table className="table">
        <thead className={`sticky top-0 z-10 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                onClick={() => onLabelClick(column.key, column?.sort)}
              >
                <div className={column.key === 'actions' ? 'actions flex--center' : 'sortingDiv'}>
                  {column.title}
                  {column?.sort && <span className='sortingDiv__icon'>
                    {/* <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.62888 12.3327V1.67373C5.62888 1.43448 5.43463 1.24023 5.19538 1.24023C4.95613 1.24023 4.76188 1.43411 4.76188 1.67373V11.2737L1.47088 7.99811C1.39476 7.91561 1.28676 7.86386 1.16638 7.86236C1.04788 7.86311 0.941008 7.91523 0.868258 7.99773L0.867883 7.99811C0.789133 8.07573 0.740008 8.18373 0.739258 8.30261C0.740008 8.42073 0.786133 8.52798 0.861508 8.60748L0.861133 8.60711L4.88338 12.6294C4.94263 12.6897 5.01876 12.7329 5.10426 12.7509L5.10726 12.7512C5.13238 12.7569 5.16163 12.7602 5.19126 12.7602C5.25163 12.7602 5.30901 12.7467 5.36038 12.7231L5.35776 12.7242C5.43763 12.6894 5.50363 12.6361 5.55313 12.5701L5.55388 12.569C5.60038 12.5056 5.62851 12.4261 5.62851 12.3399C5.62851 12.3369 5.62851 12.3342 5.62851 12.3312L5.62888 12.3327Z" fill="#CCCCCC" stroke="#CCCCCC" stroke-width="1.28" />
                      <path d="M8.99023 1.66781V12.3268C8.99023 12.5661 9.18411 12.7603 9.42373 12.7603C9.66336 12.7603 9.85723 12.5664 9.85723 12.3268V2.72381L13.1482 6.00131C13.2244 6.08381 13.3324 6.13556 13.4527 6.13706H13.4531C13.5716 6.13631 13.6781 6.08419 13.7509 6.00169L13.7512 6.00131C13.8292 5.92444 13.878 5.81794 13.8799 5.70019V5.69981C13.8791 5.58169 13.833 5.47444 13.7576 5.39494L13.758 5.39531L9.73573 1.37306C9.67648 1.31269 9.60036 1.26956 9.51486 1.25156L9.51186 1.25119C9.48673 1.24556 9.45748 1.24219 9.42786 1.24219C9.36748 1.24219 9.31011 1.25569 9.25873 1.27969L9.26136 1.27856C9.18148 1.31344 9.11548 1.36669 9.06598 1.43269L9.06523 1.43381C9.01873 1.49719 8.99061 1.57669 8.99061 1.66294C8.99061 1.66481 8.99061 1.66669 8.99061 1.66856L8.99023 1.66781Z" fill="#CCCCCC" stroke="#6A7186" stroke-width="1.28" />
                    </svg> */}

                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.909049 3.38977H1.36359V9.15248C1.36359 9.62051 1.7706 9.99994 2.27266 9.99994C2.77471 9.99994 3.18173 9.62051 3.18173 9.15248V3.38977H3.63627C4.13626 3.38977 4.54534 3.00842 4.54534 2.54231C4.54534 2.3559 4.4817 2.17791 4.36352 2.03386L2.99992 0.338946C2.63633 -0.112982 1.90901 -0.112982 1.54542 0.338946L0.181814 2.03386C0.063635 2.17791 9.46904e-10 2.3559 9.46904e-10 2.54231C-2.27259e-05 3.00842 0.40906 3.38977 0.909049 3.38977Z" fill="#85BDB5"/>
                      <path d="M9.09095 6.61017H8.63642V0.847458C8.63642 0.379428 8.2294 0 7.72735 0C7.22529 0 6.81827 0.379428 6.81827 0.847458V6.61017H6.36374C5.86375 6.61017 5.45467 6.99153 5.45467 7.45763C5.45467 7.64409 5.5183 7.82203 5.63648 7.96612L7.00009 9.66104C7.3636 10.1129 8.09107 10.1129 8.45458 9.66104L9.81819 7.96612C9.93637 7.82201 10 7.64409 10 7.45763C10 6.99153 9.59094 6.61017 9.09095 6.61017Z" fill="#31615A"/>
                    </svg>


                    {/* <Icon
                      name={sortIconMap[keyStore[column.key] ? keyStore[column.key] : 'none']}
                    // className={classnames(
                    //   'mx-2 w-2',
                    //   keyStore[column.key] ? keyStore[column.key] : 'none' !== 'none' ? 'text-primary-light' : 'text-primary-main'
                    // )}
                    /> */}
                  </span>
                  }
                </div>

              </th>
            )
            )}
            {/* <th >
                Actions
            </th> */}
          </tr>
        </thead>
        <tbody>

          {data?.length > 0 ? (
            data.map((item, index) => {
              const isAppointmentOrReview = from === 'appointment' || from === 'reviewReport';
              const isReport = from === 'report';
              const shouldDisplayApproveButton = item.from === 'ODOO';
              return (
                <tr
                  key={index}
                  onClick={() => {
                    if (setClickedItem) {
                      setClickedItem(item);
                    }
                  }}
                  style={
                    setClickedItem && clickedItem && clickedItem?._id === item?._id
                      ? { backgroundColor: 'rgb(98, 96, 128)', color: 'white' } : null }
                >
                  {columns.map((column) => (
                    <td key={column.key}>
                      {/* {column.key == 'name' &&
                            <span className='text-white bg-[#51A196] rounded-full h-6 w-6 flex items-center justify-center mr-1'>
                                {getInitials(item[column.key])}
                            </span>
                        } */}
                      {
                        column.key === 'study_research_report' &&
                        <div className='cursor-pointer' onClick={() => handleOpenReport(item)}>
                          <img src={ICONS.reportIcon} alt={'Report Icon'} />
                        </div>
                      }
                      {column.key === 'status' ? (
                        <Tooltip
                          content={`${item[column.key]} by ${item?.reportMadeBy || 'unknown'}${item?.reportMadeByRole ? ` (${item?.reportMadeByRole})` : ''}`}
                          position="bottom"
                        >
                        <span

                            style={{
                              color: getStatusColor(item?.status),
                            }}
                          >
                            {item[column.key]}
                          </span>
                        </Tooltip>
                      ) : column.key === 'cancellationReason' ? (
                        item[column.key] === "--" ? (
                          <span>{item[column.key]}</span>
                        ) : (
                          <Tooltip content={item[column.key]} position="bottom">
                            <span className='ellipsis-text'>{item[column.key]}</span>
                          </Tooltip>
                        )
                      )
                        : column.key === 'priority' ? (
                          <span
                            style={{
                              color:
                                item?.priority === "Critical" ? '#FF5C5C' :
                                  item?.priority === "Priority" ? '#007bff' :
                                    item?.priority === "Routine" ? '#28a745' :
                                      'inherit',
                            }}
                          >
                            {item[column.key]}
                          </span>
                        )
                          : column.key === 'plan' ? (
                            <span
                              style={{
                                color:
                                  item?.plan === "Basic" ? '#28a745' :
                                    item?.plan === "Standard Plan" ? '#007bff' :
                                      'inherit',
                              }}
                            >
                              {item[column.key]}
                            </span>
                          )
                            : column.key === 'type' ? (
                              from === 'report' && (
                                (role == _roleType.hospitalSuperadmin || role == _roleType.admin) &&
                                (item?.hospitalIds?.length === 2 ? 'External' : 'Internal')
                              )
                            ) : column.key === 'services' ? (
                              React.isValidElement(item[column.key]) ? (
                                item[column.key].type === Tooltip && item[column.key].props?.title ? (
                                  <Tooltip content={item[column.key].props.title} position="bottom">
                                    <span className="cellText__dark">{item[column.key].props.children}</span>
                                  </Tooltip>
                                ) : (
                                  item[column.key]
                                )
                              ) : typeof item[column.key] === 'string' ? (
                                <span className="cellText__dark">{item[column.key]}</span>
                              ) : item[column.key]?.tooltip ? (
                                <Tooltip content={item[column.key].tooltip} position="bottom">
                                  <span className="cellText__dark">{item[column.key].display}</span>
                                </Tooltip>
                              ) : (
                                <span className="cellText__dark">{item[column.key]?.display}</span>
                              )
                            )
                            : column.key === 'actions' &&
                                from === 'discountNotification' ?
                                (<div className="actions flex--center" ref={el => dropdownRef.current[index] = el}>
                                  <ul className="dropdown">
                                    <li className="dropdown__item">
                                      <button
                                        className="btn btn__secondary btn__outlined btn--rounded w-160"
                                        onClick={() => toggleDropdown(index)}
                                      >
                                        <p style={{ fontSize: '13px' }}>View More</p>
                                      </button>
                                      <ul className={`dropdownMenu ${openDropdownId === index ? 'dropdownMenu--open' : ''}`}>
                                        {(typeof actions === 'function' ? actions(item) : actions).map((action, actionIndex) => {
                                          if(action?.label !== 'Preview Invoice' && item?.status !== 'Pending') {
                                            return null;
                                          }
                                          return (
                                            <li
                                              className="dropdown__item"
                                              key={actionIndex}
                                              onClick={() => action.onClick(item)}
                                            >
                                              {action.label}
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    </li>
                                  </ul>
                                </div>)
                              : column.key === 'actions' ?
                                from === 'billingInvoice' ? (
                                  <div className="actions flex--center" ref={el => dropdownRef.current[index] = el}>
                                    <ul className="dropdown">
                                      <li className="dropdown__item">
                                        <button
                                          className="btn btn__secondary btn__outlined btn--rounded w-160"
                                          onClick={() => toggleDropdown(index)}
                                        >
                                          <p style={{ fontSize: '13px' }}>View More</p>
                                        </button>
                                        <ul className={`dropdownMenu ${openDropdownId === index ? 'dropdownMenu--open' : ''}`}>
                                          {(typeof actions === 'function' ? actions(item) : actions).map((action, actionIndex) => {
                                            const getSubmenuItems = (status) => {
                                              switch (status) {
                                                case 'Unpaid':
                                                  return [
                                                    { label: 'Preview', onClick: action.onClick },
                                                    { label: 'Post Discount', onClick: action.onClick },
                                                    { label: 'Cancel', onClick: action.onClick },
                                                  ];
                                                case 'Paid':
                                                  return [
                                                    { label: 'Preview', onClick: action.onClick },
                                                    { label: 'Cancel', onClick: action.onClick },
                                                  ];
                                                case 'Refund':
                                                  return [
                                                    { label: 'Preview', onClick: action.onClick },
                                                  ];
                                                default:
                                                  return [];
                                              }
                                            };
                                            const submenuItems = getSubmenuItems(item.invoiceStatus);
                                            return (
                                              <li
                                                className="dropdown__item"
                                                key={actionIndex}
                                                onClick={() => action.onClick(item)}
                                              >
                                                {action.label}
                                                {submenuItems.length > 0 && (
                                                  <ul className="dropdownMenu dropdownMenu--submenu">
                                                    {submenuItems.map((submenuItem, subIndex) => (
                                                      <li
                                                        className="dropdown__item"
                                                        key={subIndex}
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          submenuItem.onClick(item);
                                                        }}
                                                      >
                                                        {submenuItem.label}
                                                      </li>
                                                    ))}
                                                  </ul>
                                                )}
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      </li>
                                    </ul>
                                  </div>
                                ) :
                                  (
                                    from === 'appointment' || from === 'report' || from === 'reviewReport' ? item.status === "Cancelled" ? null : (
                                      <>
                                        <div className="actions flex--center" ref={el => dropdownRef.current[index] = el}>
                                          <ul className="dropdown">
                                            <li className="dropdown__item">
                                              {isAppointmentOrReview ? (
                                                <div onClick={() => toggleDropdown(index)} style={{ cursor: 'pointer' }}>
                                                  <button
                                                    className="btn btn__secondary btn__outlined btn--rounded w-160"
                                                    onClick={() => toggleDropdown(index)}
                                                  >
                                                    <p style={{ fontSize: '13px' }}>View More</p>
                                                  </button>
                                                </div>
                                              ) : (
                                                <button
                                                  className="btn btn__secondary btn__outlined btn--rounded w-160"
                                                  onClick={() => toggleDropdown(index)}
                                                >
                                                  <p style={{ fontSize: '13px' }}>View More</p>
                                                </button>
                                              )}
                                              <ul className={`dropdownMenu ${openDropdownId === index ? 'dropdownMenu--open' : ''}`}>
                                                {item.status === "Confirmed" && role !== _roleType.government && role !== _roleType.radiologist && role !== _roleType.resident && role !== _roleType.clinician && item?.appointmentDetails?.appointmentType === 'investigation_with_modality' && (
                                                  <li className="dropdown__item" onClick={() => sendToMWLHandler(item)}>
                                                    Resend to MWL
                                                  </li>
                                                )}
                                                {actions
                                                  .filter((action) => {
                                                    if (item.status === 'Confirmed' && from === 'appointment' && action.label === 'Send to MWL') {
                                                      return false;
                                                    }
                                                    else if (from === 'appointment') {
                                                      if (item.mppsStatus == 'COMPLETED' && action.label == 'Preview') {
                                                        return true
                                                      } else if (item.mppsStatus == 'IN PROGRESS' && (action.label == "Cancel")) {
                                                        return false
                                                      }
                                                      else if (item.mppsStatus == 'IN PROGRESS' && (action.label == "Reschedule")) {
                                                        return false
                                                      }
                                                      else if (item.mppsStatus == 'DISCONTINUED') {
                                                        return true
                                                      }
                                                    }
                                                    else if (item.status === 'Authorized' && from === 'report') {
                                                      if (role === 'Superadmin') {
                                                        return action.label === 'Edit' || action.label === 'Preview';
                                                      } else {
                                                        return action.label === 'Preview';
                                                      }
                                                    }
                                                    else if (from === 'report' && role == _roleType.technician) {
                                                      return action.label === 'Preview';
                                                    }
                                                    else if (item.status === 'Sent for Review' && from === 'report') {
                                                      return action.label === 'Edit' || action.label === 'Complete' || action.label === 'Authorize' || action.label === 'Preview'
                                                    }
                                                    else if (from === 'reviewReport') {
                                                      if (action.label == 'View Images') {
                                                        return true
                                                      }
                                                      if (item.status === 'Reviewed') {
                                                        return action.label === 'Preview';
                                                      }
                                                      else if (item.status === 'Authorized') {
                                                        return action.label === 'Preview' || action.label === 'Send Back';
                                                      }
                                                      else if (item.status === 'Completed') {
                                                        return action.label === 'Edit' || action.label === 'Preview' || action.label === 'Send Back' || action.label === 'Authorized';
                                                      }
                                                    }
                                                    else if (item.status === 'Completed' && action.label === 'Complete') {
                                                      return false
                                                    }
                                                    return true;
                                                  })
                                                  .map((action, actionIndex) => (
                                                    <li className="dropdown__item" key={actionIndex} onClick={() => action.onClick(item)}>
                                                      {action.label}
                                                    </li>
                                                  ))}
                                              </ul>
                                            </li>
                                          </ul>
                                          {
                                            from === 'appointment' && role !== _roleType.government &&
                                            <>
                                              {role !== 'technicianradiology' && <button className="btn p_0 border_0" onClick={() => handleGenerateReport(item)} title={item.title}>
                                                <img src={ICONS.reportIcon} alt={'Report Icon'} />
                                              </button>}
                                              <button className="btn p_0 border_0" onClick={() => handleStudyNavigation(item)} title="View Study">
                                                {getIcon('studies-side-menu')}
                                              </button>
                                            </>
                                          }
                                        </div>
                                      </>
                                    ) : (
                                      <div className="actions flex--center">
                                        {from === 'pricing' && item.referringDoctor == '--' ? actions?.filter(action => {
                                          if (action.id === 'deletePricing') {
                                            return null;
                                          }
                                          return true;
                                        })?.map((action, actionIndex) => (
                                          <Tooltip content={action.label} position='bottom-left' className='inline-block' key={actionIndex}>
                                            <button
                                              onClick={() => action.onClick(item)}
                                              className={`btn rounded btn p_0 border_0`}
                                            >
                                              <img src={ICONS[action.iconName]} alt={action.label} />

                                            </button>
                                          </Tooltip>
                                        )) :

                                          item.status === "Confirmed" && role !== _roleType.government && role !== _roleType.radiologist && role !== _roleType.resident && role !== _roleType.clinician && item?.appointmentDetails?.appointmentType === 'investigation_with_modality' ? (
                                            <button
                                              className="btn btn-white"
                                              onClick={() => sendToMWLHandler(item)}
                                            >
                                              <span>Resend to MWL</span>
                                            </button>
                                          ) : item.status === "Cancelled" ? null : (
                                            actions?.filter(action => {
                                              if (item.status === 'Authorized' && from === 'report') {
                                                return action.label === 'Preview';
                                              }
                                              return true;
                                            })?.map((action, actionIndex) => (
                                              <Tooltip content={action.label} position='bottom-left' className='inline-block' key={actionIndex}>

                                                {action.label === 'Approve' && !shouldDisplayApproveButton ? null : action.label === 'Approve' ? (
                                                  <button
                                                    onClick={() => action.onClick(item)}
                                                    className={`btn rounded px-2 py-1 text-white flex items-center ${approvedHospitals?.has(item._id) ? 'bg-green-600' : 'bg-teal-600'
                                                      }`}
                                                    style={{ borderRadius: '8px', fontSize: '13px' }}
                                                    disabled={approvedHospitals?.has(item._id)}
                                                  >
                                                    {approvedHospitals?.has(item._id) ? 'Approved' : 'Approve'}
                                                  </button>
                                                ) : action.id === 'togglePacs' ? (

                                                  <ToggleSwitch
                                                    onChange={() => actions.find(action => action.id === 'togglePacs')?.onChange(item)}
                                                    checked={item.active}
                                                  />
                                                ) : <button
                                                  onClick={() => action.onClick(item)}
                                                  className={`btn rounded ${action.iconName === 'UserCheck' ? 'border border-black' : 'btn p_0 border_0'}`}
                                                >
                                                  <img src={ICONS[action.iconName]} alt={action.label} />
                                                  {action.iconName === 'UserCheck' && (
                                                    <h2 className="button-text">Assign Radiologist</h2>
                                                  )}
                                                </button>}
                                              </Tooltip>
                                            ))
                                          )}
                                      </div>
                                    )
                                  ) : column.key === 'actions' ?
                                  (
                                    from === 'appointment' || from === 'report' || from === 'reviewReport' ? item.status === "Cancelled" ? null : (
                                      <>
                                        <div className="actions flex--center" ref={el => dropdownRef.current[index] = el}>
                                          <ul className="dropdown">
                                            <li className="dropdown__item">
                                              <button className="btn btn__secondary btn__outlined btn--rounded w-160" onClick={() => toggleDropdown(index)}>
                                                <p style={{ fontSize: '13px' }}>View More</p>
                                              </button>
                                              <ul className={`dropdownMenu ${openDropdownId === index ? 'dropdownMenu--open' : ''}`}>
                                                {item.status === "Confirmed" && role !== _roleType.government && role !== _roleType.radiologist && role !== _roleType.resident && role !== _roleType.clinician && item?.appointmentDetails?.appointmentType === 'investigation_with_modality' && (
                                                  <li className="dropdown__item" onClick={() => sendToMWLHandler(item)}>
                                                    Resend to MWL
                                                  </li>
                                                )
                                                }
                                                {actions
                                                  .filter((action) => {
                                                    if (item.status === 'Confirmed' && from === 'appointment' && action.label === 'Send to MWL') {
                                                      return false;
                                                    }
                                                    else if (from === 'appointment') {
                                                      if (item.mppsStatus == 'COMPLETED' && action.label == 'Preview') {
                                                        return true
                                                      } else if (item.mppsStatus == 'IN PROGRESS' && (action.label == "Cancel")) {
                                                        return false
                                                      }
                                                      else if (item.mppsStatus == 'IN PROGRESS' && (action.label == "Reschedule")) {
                                                        return false
                                                      }
                                                      else if (item.mppsStatus == 'DISCONTINUED') {
                                                        return true
                                                      }
                                                    }
                                                    else if (item.status === 'Authorized' && from === 'report' || item.status === 'Sent for Review' && from === 'report') {
                                                      return action.label === 'Preview';
                                                    }
                                                    else if (from === 'reviewReport') {
                                                      if (action.label == 'View Images') {
                                                        return true
                                                      }
                                                      if (item.status === 'Reviewed') {
                                                        return action.label === 'Preview';
                                                      }
                                                      else if (item.status === 'Authorized') {
                                                        return action.label === 'Preview' || action.label === 'Send Back';
                                                      }
                                                      else if (item.status === 'Completed') {
                                                        return action.label === 'Preview' || action.label === 'Send Back' || action.label === 'Authorized';
                                                      }
                                                    }
                                                    else if (item.status === 'Completed' && action.label === 'Complete') {
                                                      return false
                                                    }
                                                    return true;
                                                  }).map((action, actionIndex) => (
                                                    <li className="dropdown__item" key={actionIndex} onClick={() => action.onClick(item)}>
                                                      {action.label}
                                                    </li>
                                                  ))}
                                              </ul>
                                            </li>
                                          </ul>
                                          {
                                            from === 'appointment' && role !== _roleType.government &&
                                            <>
                                              {role !== 'technicianradiology' && <button className="btn p_0 border_0" onClick={() => handleGenerateReport(item)} title={item.title}>
                                              <img src={ICONS.reportIcon} alt={'Report Icon'} />
                                             </button>}
                                              <button className="btn p_0 border_0" onClick={() => handleStudyNavigation(item)} title="View Study">
                                                {getIcon('studies-side-menu')}
                                              </button>
                                            </>
                                          }
                                        </div>
                                      </>
                                    ) : (
                                      <div className="actions flex--center">
                                        {from === 'pricing' && item.referringDoctor == '--' ? actions?.filter(action => {
                                          if (action.id === 'deletePricing') {
                                            return null;
                                          }
                                          return true;
                                        })?.map((action, actionIndex) => (
                                          <Tooltip content={action.label} position='bottom-left' className='inline-block' key={actionIndex}>
                                            <button
                                              onClick={() => action.onClick(item)}
                                              className={`btn rounded btn p_0 border_0`}
                                            >
                                              <img src={ICONS[action.iconName]} alt={action.label} />

                                            </button>
                                          </Tooltip>
                                        )) :

                                          item.status === "Confirmed" && role !== _roleType.government && role !== _roleType.radiologist && role !== _roleType.resident && role !== _roleType.clinician && item?.appointmentDetails?.appointmentType === 'investigation_with_modality' ? (
                                            <button
                                              className="btn btn-white"
                                              onClick={() => sendToMWLHandler(item)}
                                            >
                                              <span>Resend to MWL</span>
                                            </button>
                                          ) : item.status === "Cancelled" ? null : (
                                            actions?.filter(action => {
                                              if (item.status === 'Authorized' && from === 'report') {
                                                return action.label === 'Preview';
                                              }
                                              return true;
                                            })?.map((action, actionIndex) => (
                                              <Tooltip content={action.label} position='bottom-left' className='inline-block' key={actionIndex}>

                                                {action.id === 'togglePacs' ? (

                                                  <ToggleSwitch
                                                    onChange={() => actions.find(action => action.id === 'togglePacs')?.onChange(item)}
                                                    checked={item.active}
                                                  />
                                                ) : <button
                                                  onClick={() => action.onClick(item)}
                                                  className={`btn rounded ${action.iconName === 'UserCheck' ? 'border border-black' : 'btn p_0 border_0'}`}
                                                >
                                                  <img src={ICONS[action.iconName]} alt={action.label} />
                                                  {action.iconName === 'UserCheck' && (
                                                    <h2 className="button-text">Assign Radiologist</h2>
                                                  )}
                                                </button>}
                                              </Tooltip>
                                            ))
                                          )}
                                      </div>
                                    )
                                  )
                                  : column.key === 'name' ? (
                                    from === 'patient' ? (
                                      <Link
                                        to={`/patient/detail/${item.uhid}`}
                                        state={{
                                          userRole: item?.
                                            patientDetail?.createdByDetails?.role
                                        }}
                                        className="text-[#51A196] hover:underline flex items-center"
                                      >
                                        <div className="profile">
                                          <div className={`${intialUserClass(index, column.key)}`}> {getInitials(item[column.key])}</div>
                                          <span className="profile__name">{item[column.key]}</span>
                                        </div>
                                      </Link>
                                    ) : from === 'hospital' ? (
                                      <Link
                                        to={`/hospital/analytics/${item?.hospitalDetail?._id}`}
                                        state={{ hospitalName: item?.name }}
                                        className="text-[#51A196] hover:underline flex items-center"
                                      >
                                        <div className="profile">
                                          <div className={`${intialUserClass(index, column.key)}`}> {getInitials(item[column.key])}</div>
                                          <span className="profile__name">{item[column.key]}</span>
                                        </div>
                                      </Link>
                                    ) : (
                                      <span className="flex items-center">
                                        <div className="profile">
                                          <div className={`${intialUserClass(index, column.key)}`}> {getInitials(item[column.key])}</div>
                                          <span className="profile__name">{item[column.key]}</span>
                                        </div>
                                      </span>
                                    )
                                  ) : (
                                    <div className="cellText">
                                      <span
                                        className={`${getDynamicClass(index, column.key, item[column.key])}`}
                                        style={checkIfDynamicClass(column.key) ? { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' } : {}}
                                      >
                                        {checkIfDynamicClass(column.key) && item[column.key] !== '--' &&
                                          <Icon className="h-[24px] w-[24px]" style={{ stroke: getColorForIcons(index) }} name={getIconType(column.key, item[column.key])} />
                                        }
                                        {item[column.key]}</span>
                                    </div>
                                  )}
                    </td>
                  ))}

                </tr>
              )
            })) : (
            <tr>
              <td colSpan={columns?.length} className="text-center py-4">
                No Data Found
              </td>
            </tr>
          )
          }
        </tbody>
      </table>
      <Loader isLoaderOpen={isLoading} />
      <SuccessModal
        isSuccessModalOpen={successPopup}
        title={'Appointment has been successfully sent to MWL.'}
        handleCloseModal={() => setSuccessPopup(false)}
      />
    </div>
  )
}

export default CustomTable
